export const tripActualStatus = {
  early: { name: 'زودتر از موعد', status: 'processing', color: 'blue' },
  okay: { name: 'سر وقت', status: 'success', color: 'green' },
  warninglate: { name: 'تاخیر', status: 'warning', color: 'orange' },
  dangerlate: { name: 'تاخیر زیاد', status: 'error', color: 'red' },
  actualnotsubmitted: { name: 'گزارش ثبت نشده', status: 'default', color: 'gray' },
};

export const recordsPerPageSize = [
  { id: 10, title: 10 },
  { id: 20, title: 20 },
  { id: 30, title: 30 },
  { id: 50, title: 50 },
];

export const customerManagerPositionId = 1;

export const stopTypeIdSelectOptions = [
  { title: 'مستقیم', id: 1 },
  { title: 'غیرمستقیم', id: 2 },
];

export const directionTypeIdSelectOptions = [
  { title: 'رفت', id: 1 },
  { title: 'برگشت', id: 2 },
  { title: 'رفت و برگشت', id: 3 },
];

export const levelTypeIdSelectOptions = [
  { title: 'اصلی', id: 1 },
  { title: 'فرعی', id: 2 },
];

export const daysDurationOptions = [
  { label: 'همان روز', value: 0 },
  { label: 'یک روز بعد', value: 1 },
  { label: 'دو روز بعد', value: 2 },
  { label: 'سه روز بعد', value: 3 },
];

export const contractorTypes = [
  { label: 'جمع آوری', value: 1 },
  { label: 'توزیع', value: 2 },
  { label: 'جمع آوری و توزیع', value: 3 },
];

export const activeSelectOptions = [
  { label: 'فعال', value: 'true' },
  { label: 'غیرفعال', value: 'false' },
];

export const availableSelectOptions = [
  { label: 'دارد', value: 'true' },
  { label: 'ندارد', value: 'false' },
];

export const AsyncSelectCustomStyle = {
  placeholder: (base) => ({
    ...base,
    color: 'var( --text-color-secondary)',
  }),
  input: (base) => ({
    ...base,
    color: 'var( --text-color)',
  }),
  singleValue: (base) => ({
    ...base,
    color: 'var( --text-color)',
  }),
  control: (base) => ({
    ...base,
    border: '1px solid var(--border-color-base)',
    boxShadow: 'none',
    backgroundColor: 'var(--input-bg-color)',
    color: 'var(--text-color) ',
    borderRadius: '6px',
    minHeight: '32px',
    height: '32px',
    '&:hover': {
      border: '1px solid #007141',
    },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: 'var(--input-bg-color)',
  }),
  option: (base, state) => ({
    ...base,
    color: 'var(--text-color)',
    '&:hover': {
      backgroundColor: 'var(--layer-bg-color)',
    },

    backgroundColor: state.isSelected && 'var(--layer-bg-color-hovered)',
  }),
};

export const productOrderStatusOptions = [
  { label: 'در انتظار تایید', value: '3' },
  { label: 'تایید شده', value: '1' },
  { label: 'عدم تایید', value: '2' },
];

export const damageStepOptions = [
  { label: 'حمل و نقل به تی هاب', value: '1' },
  { label: 'تی هاب به تیپاکسیار', value: '2' },
  { label: 'تی هاب به راننده', value: '3' },
  { label: 'حمل و نقل به سوپروایزر', value: '4' },
  { label: 'حمل و نقل به نمایندگی', value: '5' },
];

// regex
export const persianRegex = /^[\u0600-\u06FF\uFB8A\u067E\u06AF\u200C\u200F۰-۹0-9\s-()ـ/|+]+$/;
export const englishRegexRoleGroupValue = /^[a-zA-Z0-9-]+$/;
export const numberRegex = /^[0-9۰-۹]+$/;
export const mobileNumberRegex = /^(09|۰۹)[0-9۰-۹]{9}$/;

export const persianMonthNames = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];

export const paymentTypePersianNames = {
  10: {
    description: 'کسر هزینه ارسال از اعتبار باقی مانده شما',
    title: 'پرداخت اعتباری',
  },
  20: {
    description: 'دریافت هزینه ارسال از فرد گیرنده در مقصد',
    title: 'پسکرایه',
  },
  30: {
    description: 'دریافت هزینه ارسال از فرد گیرنده در مقصد و همچنین دریافت ارزش کالا از فرد گیرنده در مقصد',
    title: 'پسکرایه + دریافت ارزش کالا',
  },
  40: {
    description: 'کسر هزینه ارسال از اعتبار باقی مانده شما و همچنین دریافت ارزش کالا از فرد گیرنده در مقصد',
    title: 'پرداخت اعتباری + دریافت ارزش کالا از مشتری',
  },
  50: {
    description: 'کسر هزینه ارسال از موجودی کیف پول شما',
    title: 'پرداخت از کیف پول',
  },
  60: {
    description: 'کسر هزینه ارسال از موجودی کیف پول شما و همچنین دریافت ارزش کالا از فرد گیرنده در مقصد',
    title: 'پرداخت از کیف پول + دریافت ارزش کالا از مشتری',
  },
  70: {
    description: ' کسر بخشی از هزینه ارسال از کیف پول شما و دریافت باقی هزینه از فرد گیرنده در مقصد دریافت می شود.',
    title: 'پرداخت اشتراکی',
  },
  80: {
    description: 'هزینه به صورت نقدی سمت فرستنده دریافت می‌شود.',
    title: 'پرداخت نقدی',
  },
  100: {
    description: 'امکان پرداخت بخشی از هزینه با فرستنده به صورت نقدی ومابقی هزینه به صورت پسکرایه از گیرنده دریافت می شود.',
    title: 'پرداخت نقدی - پسکرایه',
  },
};

export const defaultSegmentPackage = {
  title: 'بسته',
  latinTitle: 'C',
  ceilingCompensationPrice: 1000000000,
  floorCompensationPrice: 0,
  taxtPercent: 40,
  currencyId: 1,
  id: 20,
};

export const NoPackagingRequiredHeavy = {
  title: 'نیاز به بسته بندی ندارد',
  width: 0,
  length: 0,
  height: 0,
  minWidth: 10,
  minLength: 10,
  minHeight: 10,
  maxWidth: 80,
  maxLength: 120,
  maxHeight: 120,
  maxWeight: 100,
  minWeight: 30,
  minPrice: 4000000,
  maxPrice: 1000000000,
  contractCustomerMaxPrice: 3000000000,
  order: 0,
  editable: true,
  packagingGroupId: 60,
  packagingGroupTitle: 'بسته',
  maxGlueAmount: 0,
  maxBubbleWrapAmount: 0,
  maxSalary: 0,
  id: 521,
};

export const NoPackagingRequiredPacket = {
  title: 'نیاز به بسته بندی ندارد',
  width: 2,
  length: 1,
  height: 0,
  minWidth: 0,
  minLength: 0,
  minHeight: 0,
  maxWidth: 200,
  maxLength: 200,
  maxHeight: 100,
  maxWeight: 100,
  minWeight: 1,
  minPrice: 4000000,
  maxPrice: 1000000000,
  contractCustomerMaxPrice: 3000000000,
  order: 0,
  editable: true,
  packagingGroupId: 20,
  packagingGroupTitle: 'بسته',
  maxGlueAmount: 0,
  maxBubbleWrapAmount: 0,
  maxSalary: 0,
  id: 504,
};

export const NoPackagingRequiredPocket = {
  title: 'نیاز به بسته بندی ندارد',
  width: 44.5,
  length: 44.5,
  height: 0,
  minWidth: 0,
  minLength: 0,
  minHeight: 0,
  maxWidth: 45,
  maxLength: 45,
  maxHeight: 5,
  maxWeight: 2,
  minWeight: 0.1,
  minPrice: 2000000,
  maxPrice: 20000000,
  contractCustomerMaxPrice: 20000000,
  order: 0,
  editable: true,
  packagingGroupId: 10,
  packagingGroupTitle: 'پاکت',
  maxGlueAmount: 0,
  maxBubbleWrapAmount: 0,
  maxSalary: 0,
  id: 507,
};
